import { IMessagingService } from "../services";
import { Component } from "./component";

class CardsGridClickableComponent extends Component {
    
    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);

        componentEl.addEventListener("click", (e) => {
            const target = e.target as HTMLElement;
            const targetHref = target.getAttribute("href");
            const hasVideo = target.closest<HTMLElement>('.js-video-component') !== null;
            const clickableCard = target.closest<HTMLElement>('.js-card-clickable[data-url]');

            if (clickableCard && !hasVideo && !targetHref) {

                var linkTarget = clickableCard.dataset.target;

                if (linkTarget) {
                    window.open(clickableCard.dataset.url, linkTarget);
                }
                else {
                    window.location.href = clickableCard.dataset.url;
                }

                e.preventDefault();
            }
        });
        
    }
}

export { CardsGridClickableComponent };
